import { Skeleton } from '@picsart/design-system/components/Skeleton';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';

import useStyles from './styles';

// Bar widths are proportions of the text column, so they track the row width.
const TITLE_WIDTH = '55%';
const CATEGORY_WIDTH = '35%';

/**
 * Placeholder for one `SearchSuggestionRow`, composed from DS `Skeleton`
 * atoms — they own the shimmer (including its RTL direction) and the
 * `aria-hidden`, so this file carries layout only.
 *
 * The padding, gap, and thumbnail size mirror the real row so a loading
 * popover is exactly the height it will be once results land.
 */
const SearchSuggestionRowSkeleton = () => {
  const classes = useStyles();

  return (
    <div className={classes.row} data-testid="search-suggestion-skeleton">
      <Skeleton width={Spacings.s48} height={Spacings.s48} borderRadius={CornerRadius.r8} className={classes.thumbnail} />
      <div className={classes.text}>
        <Skeleton width={TITLE_WIDTH} height={Spacings.s12} borderRadius={CornerRadius.r4} />
        <Skeleton width={CATEGORY_WIDTH} height={Spacings.s10} borderRadius={CornerRadius.r4} />
      </div>
    </div>
  );
};

export default SearchSuggestionRowSkeleton;
